import Settings from "./settings.service";
import Storage from "../services/storage.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import CONSTANTS from "./constants.service";
import Products from "./products.service";

var ApplePay = {};


ApplePay.getApplyPayConfigureStatus = () => {
	if (!Products.isFeatureAllowed(CONSTANTS.APPLE_PAY_FEATURE)) {
		return Helpers.emptyReject();
	}
	if (window.ApplePaySession && Helpers.isHTTPS()) {
		return Promise.resolve(window.ApplePaySession.canMakePayments());
	}
	return Helpers.emptyReject();
};

ApplePay.createApplePaymentRequest = (totalAmount) => {
	Helpers.debug_payment("totalAmount", totalAmount);
	return {
		countryCode: Settings.apple_pay_country_code,
		currencyCode: Settings.apple_pay_currency,
		supportedNetworks: Settings.apple_pay_supported_networks,
		merchantCapabilities: ["supports3DS"],
        // DYNAMIC VALUE
		total: { label: "Total", amount: totalAmount },
		version: Settings.apple_pay_version_number,
	};
};

ApplePay.getPaymenOperation = (operation) => {
	switch (operation) {
		case "purchaseWithAuth":
			return 11;
		case "auth":
			return 13;
		case "purchase":
			return 14;
		default:
			return 11;
	}
};

ApplePay.getAppleParameters = (paymentToken, paymentData) => {
    // const topNumberData = Storage.get("TopNumberData",true)
	let data = {
        "apple_network": paymentToken?.paymentMethod?.network || "",
        "apple_displayName": paymentToken?.paymentMethod?.displayName || "",
        "apple_type": paymentToken?.paymentMethod?.type,
        "apple_data": paymentToken?.paymentData?.data,
        "apple_signature": paymentToken?.paymentData?.signature,
        "apple_transactionId": paymentToken?.paymentData?.header?.transactionId,
        "apple_ephemeralPublicKey": paymentToken?.paymentData?.header?.ephemeralPublicKey,
        "apple_publicKeyHash": paymentToken?.paymentData?.header?.publicKeyHash,
        "apple_application_data": "",
        "payment_operation": ApplePay.getPaymenOperation(),
    };

    // Append new key-value pairs from paymentData to data
    // DYNAMIC VALUE
    for (const key in paymentData) {
        if (paymentData.hasOwnProperty(key)) {
            data[key] = paymentData[key];
        }
    }
	// data["apple_network"] = paymentToken?.paymentMethod?.network || "";
	// data["apple_displayName"] = paymentToken?.paymentMethod?.displayName || "";
	// data["apple_type"] = paymentToken?.paymentMethod?.type;
	// data["apple_data"] = paymentToken?.paymentData?.data;
	// data["apple_signature"] = paymentToken?.paymentData?.signature;
	// data["apple_transactionId"] = paymentToken?.paymentData?.header?.transactionId;
	// data["apple_ephemeralPublicKey"] = paymentToken?.paymentData?.header?.ephemeralPublicKey;
	// data["apple_publicKeyHash"] = paymentToken?.paymentData?.header?.publicKeyHash;
	// data["apple_application_data"] = "";
	// data["data"] = topNumberData;
    // data["number"] = "";
    // data["amount"] = "";
	// data["payment_operation"] = ApplePay.getPaymenOperation();
	return data;
};

ApplePay.registerAndPayApple = (data, apiEndpoint) => {
    // REFERNCE_apiEndpoint: {
	// 	endpoint: "/postpaid_bills/pay_with_apple_web",
	// 	method: "post"
	// }
	let config = {
		method: apiEndpoint.method,
		url: apiEndpoint.endpoint,
		data: data,
	};
	return HTTP(config);
}

ApplePay.sendPaymentToken = (paymentToken, paymentData, apiEndpoint) => {
	return new Promise(function (resolve, reject) {
		let data = ApplePay.getAppleParameters(paymentToken, paymentData);
		ApplePay.registerAndPayApple(data, apiEndpoint)
			.then((res) => {
				resolve(res);
			})
			.catch((error) => {
				reject(error);
			});
	});
};


ApplePay.validateAppleUrlNew = () => {
	let config = {
		method: "post",
		url: "apple/request_payment_session_new",
	};
	return HTTP(config);
};

ApplePay.appleBegin = (totalAmount, paymentData, apiEndpoint) => {
	// Params Definition: Total Amount, Payment Object for Apple, API details like endpoint, method. 
	Storage.clear("paymentFailedError");
	let successURL = apiEndpoint?.successURL;
	let failureURL = apiEndpoint?.failureURL;
	if(!totalAmount) return;
	let request = ApplePay.createApplePaymentRequest(totalAmount); // PKPaymentRequest

	let session = new window.ApplePaySession(
		Settings.apple_pay_version_number,
		request
	);
				session.begin();
				Helpers.debug_payment("session.begin()");
                Storage.set("paymentFailedError", true, true);

				session.oncancel = (event) => {
					Helpers.debug_payment("session.oncancel event", event);
					Storage.clear("selected_payment_method");
					// Storage.set("paymentFailedError", true, true);
					window.location.href = failureURL;
				};

				session.onpaymentauthorized = (event) => {
					Storage.set("paymentFailedError", true, true);
					Helpers.debug_payment("session.onpaymentauthorized event", event);
					ApplePay.sendPaymentToken(event.payment.token, paymentData, apiEndpoint)
						.then((res) => {

							Helpers.debug_payment("sendPaymentToken res", res);

							let status = window.ApplePaySession.STATUS_SUCCESS;
							session.completePayment(status);
							// Storage.set("paymentFailedError", false, true);
							window.location.href = successURL;
						})
						.catch((error) => {
							session.abort();
							// Storage.set("paymentFailedError", true, true);
							window.location.href = failureURL;
						});
				};

				session.onvalidatemerchant = (event) => {
					Storage.clear("paymentFailedError");
					Helpers.debug_payment("session.onvalidatemerchant event", event);
					if (event.validationURL) {
						Storage.set("paymentFailedError", true, true);
						ApplePay.validateAppleUrlNew()
							.then((merchantSession) => {
								Helpers.debug_payment("merchantSession", merchantSession);
								session.completeMerchantValidation(merchantSession.data);
							})
							.catch((error) => {
								// Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
								Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
								session.abort();
								// FAILED SCENARIO
								Storage.clear("selected_payment_method");
								// Storage.set("paymentFailedError", true, true);
								window.location.href = failureURL;
							});
					} else {
						// Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
						Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
						// FAILED SCENARIO
						Storage.clear("selected_payment_method");
						// Storage.set("paymentFailedError", true, true);
						window.location.href = failureURL;
					}
				};
};

ApplePay.topupVerifyConfirmationResponse = (data) => {
	Helpers.debug_payment("Payments.topupVerifyConfirmationResponse(data)", data);
	let config = {
		method: "post",
		url: "/quick_topup/online_oneoff_confirmation",
		data: data,
	};
	return HTTP(config);
};

export default ApplePay;
